import React, {  useState } from "react";
import iconLogo from "../assets/logo.png";
import { BiLike } from "react-icons/bi";
import { MdOutlineFileUpload } from "react-icons/md";
import type { UploadFile } from 'antd';
import { Button, Upload } from 'antd';
import { Flex, Rate } from 'antd';
import { MdOutlineSupportAgent } from "react-icons/md";
import { message } from 'antd';
import './ContactFormStyle.scss';
import { apiCall } from '../api/apiRoutes.ts';
import { NetworkInfo } from "../constants/network.ts";
import showMessageQueue from '../utils/messageUtils.js';

const ContactForm = () => {
  const [activeTab, setActiveTab] = useState("support"); // Initial active tab
  const [messageText,setMessageText]=useState('')
  const [errorMessage,setErrorMessage]=useState('')
  const [loading,setLoading]=useState(false)
  const [imageError,setImageError]=useState(false)
  const [imageErrorMessage,setImageErrorMessage]=useState('')
  const [isFocused, setIsFocused] = useState(false);
  const [hasText, setHasText] = useState(true);
  const [defaultRating,setDefaultRating]=useState(0)
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [messages, contextHolder] = message.useMessage();

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Update active tab
    setMessageText('');
    setErrorMessage('')
    setImageError(false);
    setImageErrorMessage('')
    setIsFocused(false)
    setHasText(true)
    setDefaultRating(0)
    setFileList([])
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    const text = event.target.value;
    const trimmedText = text.trim();

    setMessageText(text);
    setHasText(trimmedText.length > 0); // Ensures text contains valid characters

    if (trimmedText.length === 0) {
      setErrorMessage("The message cannot be empty or contain only spaces.");
    } else if (text.length > 1500) {
      setErrorMessage("The message must be at most 1500 characters.");
    } else {
      setErrorMessage(""); // Clear error if valid
    }
  };

  /* File Upload Js Start */
  const customRequest = ({ onSuccess }: any) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleChange = (info) => {
    let newFileList = [...info.fileList];
    // filtering out files greater than 2MB
    newFileList = newFileList.filter((file) => {
      if (file.size && file.size / 1024 / 1024 > 2) { // Ensure file.size is defined
          // message.error(`${file.name} is too large! Max size is 2MB.`);
          setImageError(true)
          setImageErrorMessage(`${file.name} is too large! Max size is 2MB.`)
          return false;

      }else{
          setImageError(false)
          setImageErrorMessage(``)
          return true;
      }
    });
    // limit the number of uploaded files (keep only the last 1)
    newFileList = newFileList.slice(-1);
    // read from response and show file link
    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });
    setFileList(newFileList);
};

  /* File upload js end */
  const onchangeTextArea = (e) => {
    const text = e.target.value;
    const trimmedText = text.trim();

    setMessageText(text);
    setHasText(trimmedText.length > 0); // Ensures text contains valid characters

    if (trimmedText.length === 0) {
      setErrorMessage("The message cannot be empty or contain only spaces.");
    } else if (text.length > 1500) {
      setErrorMessage("The message must be at most 1500 characters.");
    } else {
      setErrorMessage(""); // Clear error if valid
    }
  };




  // request support api
  const requestSupport = async (e) => {
    e.preventDefault();
    if(!hasText){
      return
    }
    const formData = new FormData();
    const storedUser:any = localStorage.getItem('usmonUser');
    const parsedUser = JSON.parse(storedUser); // First, parse the whole object
    const currentClientId = Object.keys(parsedUser?.user?.current_client)[0]; // Get the first key from the object

    // Append each file correctly
    fileList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("attachments", file.originFileObj);
      }
    });


    // append message
    setLoading(true)
    formData.append("message", messageText.trim());
    formData.append("clientId", currentClientId);
    formData.append("email", parsedUser?.user?.email);

    try {
      const res = await apiCall(formData,`${NetworkInfo.endpoints.api}/${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.support}${NetworkInfo.endpoints.discussion}`,"postrequestmultipart",false,false,false);
      if(res?.status===200 || res?.status===201 || res?.success===true){
        setMessageText('');
        setErrorMessage('')
        setImageError(false);
        setImageErrorMessage('')
        setIsFocused(false)
        setHasText(true)
        setDefaultRating(0)
        setFileList([])
        setLoading(false)
        showMessageQueue(messages,"success",res?.message)

      } else{
        showMessageQueue(messages,"error",res?.message)
        setMessageText('')
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      setMessageText('')
      showMessageQueue(messages,"error",error?.response?.data?.message || "Error submitting form!!")
    }
  };

  const leaveFeedback=async(e)=>{
    e.preventDefault();
    if(!hasText){
      return
    }
    const storedUser:any = localStorage.getItem('usmonUser');
    const parsedUser = JSON.parse(storedUser); // First, parse the whole object
    const availableClients=parsedUser?.user?.availableClients;
    const currentClientId = Object.keys(parsedUser?.user?.current_client)[0]; // Get the first key from the object
    const foundClient:any = Object.entries(availableClients).map(([id, name]) => ({ id, name })).find(client => client.id === currentClientId); // compare correctly

    if(defaultRating===0){
      setErrorMessage("The rating must be between 1 and 5.");
      return
    }

    const data={
      rating: defaultRating,
      message: messageText.trim(),
      clientId:Number(foundClient?.id),
      email:parsedUser?.user?.email
    }
    setLoading(true)
    try {
      const res = await apiCall(data,`${NetworkInfo.endpoints.api}/${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.support}${NetworkInfo.endpoints.feedback}`,"postrequestmultipart",false,false,false);
      if(res?.status===200 || res?.status===201 || res?.success===true){
        setMessageText('');
        setErrorMessage('')
        setImageError(false);
        setImageErrorMessage('')
        setIsFocused(false)
        setDefaultRating(0)
        setHasText(true)
        setFileList([])
        setLoading(false)
        showMessageQueue(messages,"success",res?.message)
      } else{
        setLoading(false)
        setMessageText('')
        showMessageQueue(messages,"error",res?.message)
      }
    } catch (error) {
      setLoading(false)
      setMessageText('')
      showMessageQueue(messages,"error",error?.response?.data?.message || "Error submitting form!!")
    }
  }

  const setRating=(e)=>{
    setDefaultRating(e);
    if(errorMessage==='The rating must be between 1 and 5.'){
      setErrorMessage('')
    }
  }

  return (

    <div className="contact-section" id="contact-form">
      {contextHolder}
      <h2>Contact Form</h2>
      <div className="contact-inner">
        {/* Left Section */}
        <div className="contact-left">
          <div className="contact-left-logo">
            {/* Image or Icon */}
            <img src={iconLogo} alt="USMON Logo" style={{ maxHeight: "100%" }} />
          </div>

          <div className="contact-left-content">
            <h3>Let’s get in touch!</h3>
            <p>Phone: (651) 234 - 1114</p>
            <p>Email: admin@usmon.com</p>
          </div>
        </div>

        {/* Right Section */}
        <div className="contact-right">
          <p style={{ fontSize: "16px", marginBottom: "10px" }}>
            Select the Support tab if you need help with the application, or if you want to leave Feedback, select the corresponding tab.
          </p>
          <p style={{ fontSize: "16px", marginBottom: "20px" }}>
            We will contact you as soon as possible!
          </p>

          {/* Tabs */}

          <div className="contact-tabs-box">
            <div className="contact-tabs">
            <button
              className={`tab-btn ${activeTab === "support" ? "active" : ""}`}
              onClick={() => handleTabClick("support")}
            >
              <MdOutlineSupportAgent /> Request Support
            </button>
              <button
                className={`tab-btn ${activeTab === "feedback" ? "active" : ""}`}
                onClick={() => handleTabClick("feedback")}
              >
               <BiLike/>Leave Feedback
              </button>
            </div>

          {/* Tab Content */}
          {activeTab === "support" && (
            <form className="contact-form"
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
              onSubmit={(e)=>requestSupport(e)}
            >
              <div className="file-upload mb-4">
                <Upload
                  fileList={fileList}
                  onChange={handleChange}
                  accept="image/*,.docx"
                  multiple={false}
                  customRequest={customRequest}
                  >
                  <Button icon={<MdOutlineFileUpload />}> Upload .jpg, .jpeg, .png, .docx</Button>
                </Upload>
                { imageError && <span className="error">{imageErrorMessage}</span>}
              </div>

              <div className={`text-field ${errorMessage ? "error" : ""}`}>
              <label
                  htmlFor="message"
                  className={`form-label ${isFocused || hasText ? "focused-label" : ""}`}
                >
                  Message
                </label>
                <textarea
                  id="message"
                  rows={5}
                  className="form-control"
                  onFocus={() => setIsFocused(true)}
                  onBlur={handleBlur}
                  onChange={(event) =>{ onchangeTextArea(event)}}
                  required={true}
                  value={messageText}

                ></textarea>
                {errorMessage && <span className="error">{errorMessage}</span>}

                <span className={`v-counter ${ messageText?.length > 1500 ? "error" : ""}`}>
                  {messageText?.length} / 1500 characters
                </span>
              </div>
              <Button htmlType="submit" className="primary-btn" disabled={!messageText?.length || messageText?.length>1500 || imageError} loading={loading}>
                Send Message
              </Button>
            </form>
          )}
          {activeTab === "feedback" && (
            <form className="contact-form"
              onSubmit={(e)=>leaveFeedback(e)}
            >
              <div className="rating-box">
                <Flex gap="middle">
                  <span>Rate our application</span>
                  <Rate value={defaultRating} className="custom-rate" onChange={(e:any)=>setRating(e)}/>
                </Flex>
              </div>
              <div className={`text-field ${errorMessage ? "error" : ""}`}>
              <label
                  htmlFor="message"
                  className={`form-label ${isFocused || hasText ? "focused-label" : ""}`}
                >
                  Message
                </label>
                <textarea
                  id="message"
                  rows={5}
                  className="form-control"
                  onFocus={() => setIsFocused(true)}
                  onBlur={handleBlur}
                  onChange={(event) =>{ onchangeTextArea(event)}}
                  required={true}
                  value={messageText}

                ></textarea>
                {errorMessage && <span className="error">{errorMessage}</span>}

                <span className={`v-counter ${ messageText?.length > 1500 ? "error" : ""}`}>
                  {messageText?.length} / 1500 characters
                </span>
              </div>
              <Button htmlType="submit" className="primary-btn" disabled={!messageText?.length || messageText?.length>1500} loading={loading}>
                Send Message
              </Button>
            </form>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
